// home page hotspot 
  var hotspot_title = document.querySelectorAll(".focal_point"); 
  hotspot_title.forEach(function(data_title) {
    data_title.addEventListener("mouseenter", (e) => {              
        // var targetIndex = $('.tab_inner_sec .card-item').index($('.card-item[data-product-title="'+ data_title.dataset.title +'"]'));
      var targetIndex = data_title.closest('.swiper').querySelector('.card-item[data-product-title="'+ data_title.dataset.title +'"]').getAttribute('data-attr');
      var targetIndex_swiper = document.querySelector('[data-product-title="'+ data_title.dataset.title +'"]').closest('.swiper-set-child')?.swiper || false;
         if(targetIndex_swiper){
          targetIndex_swiper.slideTo(targetIndex,200,false);
         }
    });
  });

  

//Cupan code Section  
document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
  copyBtn.addEventListener("click", function () {
    let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
    if (codeElement) {
      let codeText = codeElement.innerText.trim();
      navigator.clipboard.writeText(codeText).then(() => {
        let originalText = copyBtn.innerHTML; 
        copyBtn.innerHTML = "&#10003;";
        setTimeout(() => {
          copyBtn.innerHTML = originalText;
        }, 2000);
      }).catch(err => {
        console.error("Copy failed", err);
      });
    }
  });
});
document.querySelectorAll(".discount-bar-close-icon")?.forEach(function (closeBtn) {
  closeBtn.addEventListener("click", function () {
    const coupan_popup_close = this.closest(".coupan-code.close-bar");
      coupan_popup_close?.classList.add('hidden');
  });
});
// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 6);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();